import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class AvslutaAvtalsobjektCommand extends BasicCommand<AvslutaAvtalsobjektCommand> {
    get primaryKey(): IPrimaryKey<AvslutaAvtalsobjektCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AvslutaAvtalsobjektCommand";
    constructor(init: (instance: AvslutaAvtalsobjektCommand) => void) {
        super(AvslutaAvtalsobjektCommand.$type, AvslutaAvtalsobjektCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
